import React from 'react';
import { Route, Routes } from 'react-router-dom';

import DetailPage from './DetailPage';
import Container from '../components/Container';

const Forms: React.FC = () => (
  <Routes>
    <Route
      index
      element={(
        <Container>
          <DetailPage />
        </Container>
      )}
    />
  </Routes>
);

export default Forms;
